export default __webpack_public_path__ + "static/media/pic8.5378b74e.jpg";